import _extends from "@babel/runtime/helpers/extends";
import _get from 'lodash/get';
var getInventorySpec = function getInventorySpec(data, exteriorColorSimple, pageType) {
  if (data === void 0) {
    data = {};
  }
  var spec = {};
  if (pageType !== 'dealer') {
    spec.odometer = _get(data, 'mileage.value', '0').replace(',', '').replace('miles', '') + ' mi';
  }
  spec.exteriorColor = exteriorColorSimple || _get(data, 'exterior.value', '').toUpperCase();
  return spec;
};
export var getInventoryData = function getInventoryData(inventory, pageType) {
  if (pageType === void 0) {
    pageType = '';
  }
  if (_get(inventory, 'id')) {
    var _owner$id;
    var bodyStyleCodes = inventory.bodyStyleCodes,
      exteriorColorSimple = inventory.exteriorColorSimple,
      id = inventory.id,
      _inventory$listingTyp = inventory.listingType,
      listingType = _inventory$listingTyp === void 0 ? '' : _inventory$listingTyp,
      mpgCity = inventory.mpgCity,
      mpgHighway = inventory.mpgHighway,
      _inventory$owner = inventory.owner,
      owner = _inventory$owner === void 0 ? {} : _inventory$owner,
      _inventory$pricingDet = inventory.pricingDetail,
      pricingDetail = _inventory$pricingDet === void 0 ? {} : _inventory$pricingDet,
      specifications = inventory.specifications,
      stockNumber = inventory.stockNumber,
      styleId = inventory.styleId,
      type = inventory.type,
      vin = inventory.vin,
      year = inventory.year;
    var _pricingDetail$salePr = pricingDetail.salePrice,
      salePrice = _pricingDetail$salePr === void 0 ? '' : _pricingDetail$salePr,
      _pricingDetail$msrp = pricingDetail.msrp,
      msrp = _pricingDetail$msrp === void 0 ? '' : _pricingDetail$msrp;
    var vehicleType = type && type.toUpperCase() || listingType.toUpperCase();
    var make = _get(inventory, 'make.name') || (typeof inventory.make === 'string' ? inventory.make : '');
    var model = _get(inventory, 'model.name') || (typeof inventory.model === 'string' ? inventory.model : '');
    var tileType = _get(inventory, 'productTiles.[0].tileType', '');
    var isCarFax = tileType.includes('CARFAX') || false;
    var data = _extends({
      vehicleId: pageType !== 'dealer' || isCarFax ? id : undefined,
      vin: vin,
      bodyStyle: bodyStyleCodes,
      make: make == null ? void 0 : make.toUpperCase(),
      model: model == null ? void 0 : model.toUpperCase(),
      vehicleType: vehicleType,
      fuelEconomy: (mpgCity && mpgCity + ' mpg city,') + (mpgHighway && mpgHighway + ' mpg hwy'),
      stockNumber: stockNumber,
      year: year,
      price: vehicleType === 'NEW' ? msrp : salePrice,
      chromeStyleId: styleId,
      listingCode: (_owner$id = owner == null ? void 0 : owner.id) != null ? _owner$id : null
    }, getInventorySpec(specifications, exteriorColorSimple, pageType));

    // remove all undefined
    return Object.entries(data).reduce(function (acc, _ref) {
      var key = _ref[0],
        value = _ref[1];
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
  return {};
};
export var buildListingChunks = function buildListingChunks(listings, _ref2) {
  var rank = _ref2.rank,
    listingType = _ref2.listingType;
  // build listing objects so that pixall can convert
  // r-19.lt-lstg.i-525454350.lc-70185499.n-JM1GJ1V53G1484191.m-MAZDA
  var pixallListings = listings.map(function (listing, index) {
    return _extends({
      rank: rank + index
    }, getInventoryData(listing), {
      listingCode: _get(listing, 'owner.id', null),
      listingType: listingType // lt-lstg
    });
  });

  // each impression should take up to 25 listings
  var chunkLength = Math.ceil(pixallListings.length / 25);
  var chunks = Array(chunkLength).fill([]).map(function (arr, index) {
    return pixallListings.slice(index * 25, index * 25 + 25);
  });
  return chunks;
};
export default {
  getInventoryData: getInventoryData,
  buildListingChunks: buildListingChunks
};